import { render } from "./GroupDeleteModal.vue?vue&type=template&id=44b1699d&scoped=true&ts=true"
import script from "./GroupDeleteModal.vue?vue&type=script&lang=ts"
export * from "./GroupDeleteModal.vue?vue&type=script&lang=ts"

import "./GroupDeleteModal.vue?vue&type=style&index=0&id=44b1699d&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b1699d"]])

export default __exports__